import React, { ReactNode, useEffect } from 'react';
import { api, apiStatic } from 'AurionCR/components';
import axios, { InternalAxiosRequestConfig } from 'axios';
import { prepareDates, prepareIDs } from 'utils';

const instances = [apiStatic, api, axios];
export const prepareDateToDotNet = (data: any) => {
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    return Object.entries(prepareIDs(prepareDates(data)))
      .filter(([, value]) => value !== undefined)
      .map(([path, value]) => {
        return { path, value };
      });
  }
  return data;
};
const patchDotNet5 = (conf: InternalAxiosRequestConfig) => {
  if (conf.method === 'patch' && conf.data && typeof conf.data === 'object') {
    conf.data = prepareDateToDotNet(conf.data);
  }
  return conf;
};

interface Props {
  children: ReactNode;
}

export const AxiosInterceptorPatch: React.FC<Props> = ({ children }) => {
  useEffect(() => {
    instances.map((instance) => {
      return instance.interceptors.request.use(patchDotNet5);
    });
  }, []);

  return <>{children}</>;
};
